import _createForOfIteratorHelper from "@babel/runtime/helpers/esm/createForOfIteratorHelper";
import zhCN from "./zh_CN.json";
import enUS from "./en_US.json";
import jaJP from "./ja_JP.json";
import koKR from "./ko_KR.json";
function get(source, path, defaultValue) {
  var paths = path.replace(/\[(\d+)\]/g, ".$1").split(".");
  var result = source;
  var message = defaultValue;
  var _iterator = _createForOfIteratorHelper(paths),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var p = _step.value;
      message = Object(result)[p];
      result = Object(result)[p];
      if (message === undefined) {
        return defaultValue;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return message;
}

/**
 * 创建一个国际化的操作函数
 *
 * @param locale
 * @param localeMap
 */
export var createIntl = function createIntl(locale, localeMap) {
  return {
    getMessage: function getMessage(id, defaultMessage) {
      return get(localeMap, id, defaultMessage) || defaultMessage;
    },
    locale: locale
  };
};
var zhCNIntl = createIntl("zh_CN", zhCN);
var enUSIntl = createIntl("en_US", enUS);
var jaJPIntl = createIntl("ja_JP", jaJP);
var koKRIntl = createIntl("ko_KR", koKR);
var intlMap = {
  "zh-CN": zhCNIntl,
  "en-US": enUSIntl,
  "ja-JP": jaJPIntl,
  "ko-KR": koKRIntl
};
var localesMap = {
  "zh-CN": zhCN,
  "en-US": enUS,
  "ja-JP": jaJP,
  "ko-KR": koKR
};
var intlMapKeys = Object.keys(localesMap);

/**
 * 根据 antd 的 key 来找到的 locale 插件的 key
 * @param localeKey
 */
export var findIntlKeyByAntdLocaleKey = function findIntlKeyByAntdLocaleKey(localeKey) {
  var localeName = (localeKey || 'zh-CN').toLocaleLowerCase();
  return intlMapKeys.find(function (intlKey) {
    var LowerCaseKey = intlKey.toLocaleLowerCase();
    return LowerCaseKey.includes(localeName);
  });
};
export { intlMap, localesMap };